import React, {FC, useState} from 'react';
import {FormControl, MenuItem, Select} from '@material-ui/core';

interface IMTableSelectFilterComponent {
  options: string[];
  labels: { [p: string]: string };
  onChange: (value: string) => void;
}

const MTableSelectFilterComponent: FC<IMTableSelectFilterComponent> = (
  props,
) => {
  const { options, labels, onChange } = props;

  const [value, setFilter] = useState<string | undefined>(undefined);

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string;
    onChange(value);
    setFilter(value);
  };

  return (
    <FormControl fullWidth>
      <Select id="mtable-select" value={value} onChange={handleChange}>
        <MenuItem value={undefined}>Aucun</MenuItem>
        {options?.map((option: string, index: number) => (
          <MenuItem key={`mtable-select-item-${index}`} value={option}>
            {labels[option] ?? option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MTableSelectFilterComponent;
